import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { SiteContentProvider } from "./content/siteContent";
import ScrollProgress from "./components/ScrollProgress";
import EditSite from "./pages/EditSite";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Problem from "./components/Problem";
import Unified from "./components/Unified";
import Journey from "./components/Journey";
import Difference from "./components/Difference";
import WhyNepal from "./components/WhyNepal";
import Investors from "./components/Investors";
import ForClinics from "./components/ForClinics";
import DemoForm from "./components/DemoForm";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import LegalPage from "./legal/LegalPage";
import { PRIVACY_POLICY, TERMS } from "./legal/content";

function Landing() {
  return (
    <div className="min-h-screen bg-paper text-ink" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Unified />
        <Journey />
        <Difference />
        <WhyNepal />
        <Investors />
        <ForClinics />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <SiteContentProvider>
          <BrowserRouter>
            <ScrollProgress />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/privacy" element={<LegalPage doc={PRIVACY_POLICY} testId="privacy-page" />} />
              <Route path="/terms" element={<LegalPage doc={TERMS} testId="terms-page" />} />
              <Route path="/editsite" element={<EditSite />} />
              <Route path="*" element={<Landing />} />
            </Routes>
            <CookieConsent />
            <Toaster position="bottom-right" richColors closeButton />
          </BrowserRouter>
        </SiteContentProvider>
      </LanguageProvider>
    </div>
  );
}
